import { ConfigMeasurementUnit, CurdDataSetConfig, FormFieldType } from '../types';
import { unitTypeOptions } from './choice-type-list';

export const measurementUnitDataSetConfig: CurdDataSetConfig<ConfigMeasurementUnit> = {
  entityName: 'Unidad',
  collectionName: 'Units',
  gatewayUrl: 'measurement-units',
  baseBreadcrumb: 'units',
  form: {
    listRedirectUrl: 'console/system/units/list',
    fields: [
      {
        key: 'key',
        label: 'Llave',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-12'
      },
      {
        key: 'type',
        label: 'Tipo de unidad',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-12',
        options: unitTypeOptions
      },
      {
        key: 'labelDefault',
        label: 'Etiqueta por defecto',
        type: FormFieldType.STRING,
        containerClass: 'col-md-4 col-sm-4',
        fillValue: (c) => (c?.label || {})['default'] || ''
      },
      {
        key: 'labelEs',
        label: 'Etiqueta en español',
        type: FormFieldType.STRING,
        containerClass: 'col-md-4 col-sm-4',
        fillValue: (c) => (c.label || {})['es'] || ''
      },
      {
        key: 'labelEn',
        label: 'Etiqueta en ingles',
        type: FormFieldType.STRING,
        containerClass: 'col-4 col-sm-4',
        fillValue: (c) => (c?.label || {})['en'] || ''
      },
      {
        key: 'abbr',
        label: 'Abreviatura',
        type: FormFieldType.STRING,
        containerClass: 'col-6 col-sm-6',
        optionsGateway: 'sim-cards'
      },
      {
        key: 'multiply',
        label: 'Multiplicador',
        type: FormFieldType.NUMBER,
        containerClass: 'col-6 col-sm-6'
      }
    ],
    handleObject: data => {
      const label = {
        default: data['labelDefault'],
        es: data['labelEs'],
        en: data['labelEn']
      };

      return {
        ...data,
        label
      }
    }
  },
  list: {
    pageConfig: {
      title: 'Lista de unidades del sistema',
      breadcrumb: [
        {
          title: 'Sistema',
          type: 'item',
          link: '/console/system/units/list'
        },
        {
          title: 'Unidades',
          type: 'item',
          link: '/console/system/units/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/system/units/list',
          pageName: 'Unidades del sistema'
        }
      ]
    },
    filter: [
      {
        key: 'value',
        label: 'Valor',
        type: FormFieldType.STRING,
      },
      {
        key: 'fieldKey',
        label: 'Tipo de campo',
        type: FormFieldType.OPTIONS_MULTIPLE,
        options: unitTypeOptions
      },
      {
        key: 'labelDefault',
        label: 'Etiqueta por defecto',
        type: FormFieldType.STRING,
      },

      {
        key: 'labelEs',
        label: 'Etiqueta en español',
        type: FormFieldType.STRING
      },

      {
        key: 'labelEn',
        label: 'Etiqueta en ingles',
        type: FormFieldType.STRING,
      },
    ],
    table: {
      columns: [
        {
          key: 'label', label: 'Etiqueta',
          getValue:  ({ element }) =>
            `${element.label['es'] || element.label['default'] || 'No definido'} ${element.abbr ? `(${element.abbr})`: ''}`
        },
        { key: 'key', label: 'Llave' },
        { key: 'description', label: 'Descripcion', },
        {  key: 'type', label: 'Tipo'}
      ]
    },
    actionsKeys: ['create', 'edit', 'delete']
  },
  pages: ['list', 'create', 'edit']
};
